import { Dimensions } from '../types'

export const checkForVerticalBlock = (size: Dimensions) => size.height > size.width
